// The controls strip above a scale-rank question: the one thing it offers is which view its
// sub-questions are charted in.

import { useMemo } from 'react'
import PropTypes from 'prop-types'

import { Dropdown } from 'primereact/dropdown'

import { CHART_VIEW_MAPPING } from '@aytm/app/stats/page/question-views/components/lib/constants'
import {
  getDefaultChartView,
  resolveAvailableViewModesByFormat
} from '@aytm/app/stats/page/question-views/components/controls/lib/view-modes'
import ControlsWithToggle from '@aytm/app/stats/page/question-views/components/controls/ControlsWithToggle'

const TYPE = 'sr'

const ControlsSR = ({ viewMode, format, batches, itemsCollapsed, onToggleBatches, onModelChange }) => {
  const options = useMemo(() => resolveAvailableViewModesByFormat(CHART_VIEW_MAPPING[TYPE], format), [format])

  // a single view is no choice to offer, so the strip stays out of the way
  if (null == options || 1 === options.length) return null

  return (
    <ControlsWithToggle type={TYPE} batches={batches} itemsCollapsed={itemsCollapsed} onToggleBatches={onToggleBatches}>
      <div className="p-fluid p-col-3">
        <Dropdown
          data-testid="stat-question-view-mode"
          className="p-dropdown-rounded"
          aria-label="View mode"
          ariaLabel="View mode"
          value={viewMode || getDefaultChartView(options)}
          options={options}
          optionValue="value"
          optionLabel="text"
          optionDisabled="disabled"
          fixedDropdownDir="bottom"
          onChange={event => onModelChange({ viewMode: event.value })}
        />
      </div>
    </ControlsWithToggle>
  )
}

ControlsSR.propTypes = {
  viewMode: PropTypes.string,
  format: PropTypes.object,
  batches: PropTypes.array,
  itemsCollapsed: PropTypes.bool,
  onToggleBatches: PropTypes.func,
  onModelChange: PropTypes.func
}

ControlsSR.displayName = 'ControlsSR'

export default ControlsSR
